import React, { Component } from "react";
import {
  Row,
  Col,
  Alert,
  Button,
  Container,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";


// action
import {
  getVendorMobile,
  generateOTP,
  CheckOTP,
} from "../../store/VendorQuotation/actions";

// import images
import logodark from "../../assets/images/absolin_logo.png";

class VendorLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      VendorOTP: "",
      OTPError: null,
    };
  }
  componentDidMount() {
    this.props.getVendorMobile(this.props.match.params.token);
   
    // localStorage.setItem("access_token1", this.props.match.params.token);
  }
  GetgenerateOTP() {
    this.props.generateOTP(this.props.match.params.token);
  }
  handleChange(e) {
    this.setState({
      VendorOTP: e.target.value,
    });
  }
  GetSubmitOTP() {
    if (this.state.VendorOTP !== "") {
      this.setState({
        OTPError: null,
      });
      this.props.CheckOTP(
        {
          token: this.props.match.params.token,
          otp: this.state.VendorOTP,
        },
        this.props.history
      );
    } else {
      this.setState({
        OTPError: "Enter OTP",
      });
    }
  }

  render() {
  
    return (
      <React.Fragment>
        <div className="home-btn d-none d-sm-block">
          <Link to="/">
            <i className="mdi mdi-home-variant h2 text-white"></i>
          </Link>
        </div>
        <div>
          <Container fluid className="p-0">
            <Row className="no-gutters">
              <Col xl={5}>
                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                  <div className="w-100">
                    <Row className="justify-content-center">
                      <Col lg={8}>
                        <div>
                          <div
                            className="p-4 mt-5 form-bg"
                            style={{ minHeight: "350px" }}
                          >
                            <div className="text-center">
                              <div>
                                <Link to="/" className="logo">
                                  <img src={logodark} height="60" alt="logo" />
                                </Link>
                              </div>

                              <h4 className="font-size-18 m-2">Vendor Login</h4>
                              {/* <p className="text-muted">Reset your password to Absolin.</p> */}
                            </div>
                            {/* {this.props.forgetError && this.props.forgetError ?
                                                <Alert color="danger" className="mb-4">{this.props.forgetError}</Alert> : null }
                                            {
                                            this.props.message ? 
                                                <Alert color="success" className="mb-4">{this.props.message}</Alert> : null
                                            } */}
                            {this.state.OTPError != null && (
                              <Alert color="danger" className="m-4">
                                {this.state.OTPError}
                              </Alert>
                            )}
                            {this.props.loginError?.all != null && (
                              <Alert color="danger" className="m-4">
                                {this.props.loginError?.all}
                              </Alert>
                            )}

                            <FormGroup className="auth-form-group-custom m-4">
                              <i className="ri-phone-line auti-custom-input-icon"></i>
                              <Label htmlFor="VendorPhone">Mobile No</Label>
                              <Input
                                name="VendorPhone"
                                value={this.props.VendorMobile.vendor_mobile}
                                type="text"
                                pattern="[1-9]{1}[0-9]{9}"
                                disabled={true}
                                className="form-control"
                                id="VendorPhone"
                                placeholder="Enter Mobile no"
                              />
                            </FormGroup>
                            {this.props.otp != null && (
                              <FormGroup className="auth-form-group-custom m-4">
                                <i className="ri-lock-unlock-line auti-custom-input-icon"></i>
                                <Label htmlFor="VendorOTP">OTP</Label>
                                <Input
                                  name="VendorOTP"
                                  value={this.state.VendorOTP}
                                  type="text"
                                  pattern="[1-9]{1}[0-9]{4}"
                                  validate={{ required: true }}
                                  className="form-control"
                                  id="VendorOTP"
                                  placeholder="Enter OTP"
                                  onChange={(e) => this.handleChange(e)}
                                />
                              </FormGroup>
                            )}

                            <div className="mt-4 text-center">
                              {this.props.otp == null && (
                                <Button
                                  color="primary"
                                  className="w-md waves-effect waves-light"
                                  type="submit"
                                  disabled={
                                    this.props.VendorMobile.vendor_mobile ==
                                    null
                                      ? true
                                      : false
                                  }
                                  onClick={() => this.GetgenerateOTP()}
                                >
                                  {this.props.loading
                                    ? "Loading..."
                                    : "Send OTP"}
                                </Button>
                              )}
                              {this.props.otp != null && (
                                <Button
                                  color="primary"
                                  className="w-md waves-effect waves-light"
                                  type="submit"
                                  onClick={() => this.GetSubmitOTP()}
                                >
                                  {this.props.loading ? "Loading..." : "Submit"}
                                </Button>
                              )}
                            </div>
                          </div>

                          <div className="mt-5 text-center">
                            <p>© 2021 Absolin.</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col xl={7}>
                <div className="authentication-bg"></div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { VendorMobile, loginError, otp, loading } = state.VendorQuotation;
  return { VendorMobile, loginError, otp, loading };
};

export default withRouter(
  connect(mapStatetoProps, { getVendorMobile, generateOTP, CheckOTP })(
    VendorLogin
  )
);
